import { connect } from 'react-redux';
import LaporanPengunjung from '../../../views/Library/LaporanPengunjung/LaporanPengunjung.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(LaporanPengunjung);
